import { ReduxState } from '../types/ReduxState';

export const initialState: ReduxState = {
  isOpen: false,
  message: '',
};
